import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const DashboardPreview = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentSection = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="text-center mb-16">
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              Simple, distraction-free interface
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Everything you need, nothing you don't. Book a session in seconds.
            </p>
          </div>

          <div className="rounded-3xl overflow-hidden shadow-2xl border border-gray-200 bg-gray-50">
            <img
              src={`${process.env.PUBLIC_URL}/dashboard-preview.png`}
              alt="VibeyFocus Dashboard Preview"
              className="w-full h-auto"
              onError={(e) => {
                e.target.style.display = 'none';
                console.error('Failed to load dashboard preview image');
              }}
            />
          </div>

          <div className="text-center mt-12">
            <Link
              to="/register"
              className="inline-block px-8 py-4 bg-primary-600 hover:bg-primary-700 text-white text-lg font-medium rounded-full transition-all shadow-lg hover:shadow-xl hover:scale-105"
            >
              Start a session
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DashboardPreview;
